import { render, staticRenderFns } from "./SelectSample.vue?vue&type=template&id=148acdfd&"
import script from "./SelectSample.vue?vue&type=script&lang=js&"
export * from "./SelectSample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports